/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Simulate_HintInputs */

const en_billing_simulate_hint = /** @type {(inputs: Billing_Simulate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dev mode: no gateway keys found. Simulate a settlement to test the flow.`)
};

const id_billing_simulate_hint = /** @type {(inputs: Billing_Simulate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode dev: kunci gateway tidak ditemukan. Simulasikan settlement untuk menguji alur.`)
};

/**
* | output |
* | --- |
* | "Dev mode: no gateway keys found. Simulate a settlement to test the flow." |
*
* @param {Billing_Simulate_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_simulate_hint = /** @type {((inputs?: Billing_Simulate_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Simulate_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_simulate_hint(inputs)
	return en_billing_simulate_hint(inputs)
});